import { createDomainApi, type ExtractEntityType } from '@skylabs-digital/react-proto-kit';

import { failedNotificationSchema } from '../schemas/failedNotification.schema';

export const failedNotificationsApi = createDomainApi(
  'notifications/failed',
  failedNotificationSchema,
);

export type FailedNotificationEntity = ExtractEntityType<typeof failedNotificationsApi>;
